import React from 'react';
import Header from '../components/Header/Header';
import Background from '../components/Background/Background';
import helixImg from '../assets/helix.png';
import '../styles/PatientNotFound.css';

export default function Forbidden() {
  return (
    <>
      <Header />
      <Background>
        <div className="not-found-message">
          <h2>Þú hefur ekki aðgang að þessari síðu</h2>
        </div>
        <img src={helixImg} alt="Helix" className="background-helix" />
      </Background>
    </>
  );
}
